import React from 'react';
import { Typography, Grid } from '@mui/material';

import UtilChart from 'views/EcosystemDetail/Utilization/UtilChart';
import TopUsage from 'views/EcosystemDetail/Utilization/TopUsage';
import Counters from './Counters';

const Utilization = () => (
  <>
    <Typography component="h2" sx={{ color: '#1A2E42', fontSize: 34, lineHeight: '42px' }}>
      Utilization
    </Typography>
    <Grid container spacing={3} mt={1}>
      <Grid item xs={12} lg={6} data-testid="util-chart" sx={{ height: 292 }}>
        <UtilChart />
      </Grid>
      <Grid item xs={12} lg={6} data-testid="util-count" sx={{ height: 292 }}>
        <Counters />
      </Grid>
      <Grid item xs={12} lg={6} data-testid="network-top-application">
        <TopUsage attributes="application" logAttr="Application" label="Most Active Apps" />
      </Grid>
      <Grid item xs={12} lg={6} data-testid="network-top-user">
        <TopUsage attributes="user" logAttr="User" label="Most Active Users" />
      </Grid>
      <Grid item xs={12} lg={6} data-testid="network-top-things">
        <TopUsage attributes="device_id" logAttr="DeviceID" label="Most Active Things" />
      </Grid>
      <Grid item xs={12} lg={6} data-testid="network-top-gateways">
        <TopUsage attributes="gateway_id" logAttr="GatewayID" label="Most Active Gateways" />
      </Grid>
    </Grid>
  </>
);

export default Utilization;
